import { Button } from 'antd';
import { FaLock } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useConfirmPaymentBadge } from './hooks/use-confirm-payment-badge';
import { useConfirmPayment } from './hooks/use-confirm-payment';
import { ReviewPaymentModal } from './review-payment-modal';
import { ConfirmPaymentModal } from './confirm-payment-modal';
import { CancelPaymentRequestModal } from './cancel-payment-request-modal';
import { ConfirmPaymentLoadWalletModal } from './confirm-payment-load-wallet-modal';

export function ConfirmPaymentHeaderBadge() {
  const { t } = useTranslation();

  const { hasPendingOrders, count, firstPendingOrderId } = useConfirmPaymentBadge();
  const confirmPayment = useConfirmPayment();

  if (!hasPendingOrders) return null;

  return (
    <>
      <Button
        type="default"
        className="rounded-4xl! text-text-800! p-0! size-9! md:h-10! md:w-auto! md:px-2.5! gap-1.5! border border-amber-100! bg-amber-50!"
        onClick={() => firstPendingOrderId && confirmPayment.openReview(firstPendingOrderId)}
      >
        <FaLock className="text-amber-700 hidden md:inline-flex" size={20} />
        <span className="hidden md:inline">{t('confirm_payment')}</span>
        {count > 0 && (
          <span className="inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-red-500 text-white text-xs font-semibold leading-none">
            {count}
          </span>
        )}
      </Button>

      <ReviewPaymentModal
        open={confirmPayment.step === 'review'}
        loading={confirmPayment.paymentOrderResult.loading}
        paymentOrder={confirmPayment.paymentOrder}
        onClose={confirmPayment.handleClose}
        onCancelClick={confirmPayment.openCancelRequest}
        onContinue={confirmPayment.goToConfirmPayment}
      />

      <ConfirmPaymentModal
        open={confirmPayment.step === 'confirm'}
        walletLoading={confirmPayment.walletResult.loading}
        walletBalance={confirmPayment.walletBalance}
        totalAmount={confirmPayment.totalAmount}
        quantity={confirmPayment.paymentOrder?.itemsQuantity}
        isInsufficientBalance={confirmPayment.isInsufficientBalance}
        isAutoRechargeEnabled={confirmPayment.isAutoRechargeEnabled}
        tooltipMessage={confirmPayment.getTooltipMessage()}
        confirming={confirmPayment.confirming}
        onClose={confirmPayment.handleClose}
        onBack={confirmPayment.backToReview}
        onConfirm={confirmPayment.handleConfirmPayment}
        onLoadWallet={confirmPayment.handleLoadWallet}
      />

      <CancelPaymentRequestModal
        open={confirmPayment.step === 'cancel-request'}
        amount={confirmPayment.totalAmount}
        type={confirmPayment.paymentOrder?.type}
        rejecting={confirmPayment.rejecting}
        onKeepRequest={confirmPayment.keepRequest}
        onCancelRequest={confirmPayment.cancelPaymentRequest}
      />

      <ConfirmPaymentLoadWalletModal
        payModal={confirmPayment.payModal}
        paymentMethodsList={confirmPayment.paymentMethodsList}
        loadWallet={confirmPayment.loadWallet}
        totalAmount={confirmPayment.totalAmount}
        onLoaded={confirmPayment.handleWalletLoaded}
      />
    </>
  );
}
